import { render } from "./ConfigOpenAi.vue?vue&type=template&id=38cd3d9e"
import script from "./ConfigOpenAi.vue?vue&type=script&lang=js"
export * from "./ConfigOpenAi.vue?vue&type=script&lang=js"

import "./ConfigOpenAi.vue?vue&type=style&index=0&id=38cd3d9e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__